import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const TileGrid = () => (
  <ComponentDocs name="<TileGrid/>" entry="TileGrid" propsEntry="TileGridProps">
    <ComponentExample
      name="Component tiles"
      import={import("examples/Tiles/TileGrid/ComponentTilesExample")}
      rawImport={import("examples/Tiles/TileGrid/ComponentTilesExample?raw")}
    />
    <ComponentExample
      name="Render tiles"
      import={import("examples/Tiles/TileGrid/RenderTilesExample")}
      rawImport={import("examples/Tiles/TileGrid/RenderTilesExample?raw")}
    />
    <ComponentExample
      name="Custom breakpoints"
      import={import("examples/Tiles/TileGrid/CustomBreakpointsExample")}
      rawImport={import("examples/Tiles/TileGrid/CustomBreakpointsExample?raw")}
    />
    <ComponentExample
      name="Tile click"
      import={import("examples/Tiles/TileGrid/TileClickExample")}
      rawImport={import("examples/Tiles/TileGrid/TileClickExample?raw")}
    />
    <ComponentExample
      name="Tile link"
      import={import("examples/Tiles/TileGrid/TileLinkExample")}
      rawImport={import("examples/Tiles/TileGrid/TileLinkExample?raw")}
    />
    <ComponentExample
      name="Empty message"
      import={import("examples/Tiles/TileGrid/EmptyTileGridExample")}
      rawImport={import("examples/Tiles/TileGrid/EmptyTileGridExample?raw")}
    />
  </ComponentDocs>
);

export default TileGrid;
